import React from 'react';
import { Navigate } from 'react-router-dom';

const AdminRoute = ({ isAuthenticated, currentUser, children }) => {
    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    if (currentUser?.role !== 'admin') {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default AdminRoute;